module.exports = __webpack_public_path__ + "img/redacao_corrigida.7c5d9bf5.svg";